"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

window.Event = new (function () {
  function _class() {
    _classCallCheck(this, _class);

    this.vue = new Vue();
  }

  _createClass(_class, [{
    key: "fire",
    value: function fire(event) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.vue.$emit(event, data);
    }
  }, {
    key: "listen",
    value: function listen(event, callback) {
      this.vue.$on(event, callback);
    }
  }]);

  return _class;
}())();


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/utilities/event.js
// module id = X0HQ
// module chunks = 0 1